import { useCallback, useState } from 'react';

interface IProps {
	text: string;
	className: string;
	onClick: (callback: () => void) => void;
}

export const Submit = ({ text, className, onClick }: IProps) => {
	const [loading, setLoading] = useState<boolean>(false);
	const onClickCallback = useCallback(() => {
		setLoading(true);
		onClick(() => setLoading(false));
	}, [onClick]);

	if (loading) {
		return (
			<button className={className + ' disabled'} disabled={true}>
				{text}
			</button>
		);
	}

	return (
		<button className={className} onClick={onClickCallback}>
			{text}
		</button>
	);
};
